module.exports = __webpack_public_path__ + "img/twitter.d75ebe95.svg";